import { Typography } from 'components/ui/typography';

import { MerchandiseCard } from './MerchandiseCard';

export function EmptyState() {
  return (
    <MerchandiseCard className="bg-striped items-center justify-center">
      <div className="flex flex-col items-center gap-1 text-center">
        <Typography variant="h3" as="h3">
          No selected product
        </Typography>
        <Typography variant="small" as="p">
          Paste in a product URL above to get started.
        </Typography>
      </div>
    </MerchandiseCard>
  );
}
